if (!customElements.get('grid-load-more')) {
  customElements.define('grid-load-more', class GridLoadMore extends HTMLElement {
    constructor() {
      super();
      // Dehde (PLP A5): the load-more control is an <a href> (crawlable next page); keep <button> for other callers
      this.button = this.querySelector('button, a[data-dehde-load-more]');
      this.loader = this.querySelector('[data-loader]');
    }

    connectedCallback(){
      if(!this.button) return;
      this.initialize();
    }

    initialize(){
      if(this.dataset.infinite === 'true') this.requested = false;
      this.setListeners();
    }

    setListeners(){
      this.loadMore = this.onLoadMore.bind(this);
      this.button.addEventListener('click', this.loadMore);
      if(this.dataset.infinite === 'true') window.addEventListener('scroll', this.loadInfinite.bind(this));
    }

    loadInfinite(){
      const handleObserver = (entries, observer) => {
        observer.unobserve(this);
        entries.forEach(entry => {
          if(entry.isIntersecting){
            if(this.requested) return;
            this.button.dispatchEvent(new Event('click'));
            this.requested = true;
          } else{
            this.requested = false;
          }
        });
      }
      new IntersectionObserver(handleObserver, {rootMargin: '0px 0px -60px 0px'}).observe(this);
    }

    onLoadMore(event){
      event.preventDefault();
      this.button.classList.add('disabled');
      this.loader.classList.remove('hidden');
      this.showButton = true;
      // Dehde (PLP A5): fetch the section, not the page (was ~1.7 MB per click). The replaced <grid-load-more> below
      // is a new element instance carrying the next data-url / data-section from Liquid.
      let url = this.dataset.url;
      if(this.dataset.section){
        const sep = url.includes('?') ? '&' : '?';
        url = url + sep + 'section_id=' + encodeURIComponent(this.dataset.section);
      }
      fetch(url)
        .then(response => response.text())
        .then(text => {
          let tempDiv = document.createElement('div');
          tempDiv.innerHTML = text;
          let columns = tempDiv.querySelectorAll('[data-render-columns]');
          let paginationWrapper = document.querySelector('[data-loader-parent]');
          let newPagination = tempDiv.querySelector('[data-loader-parent]');
          let parentNode = paginationWrapper.parentNode;
          columns.forEach(column => {
            parentNode.insertBefore(column, paginationWrapper);
          });
          if(newPagination){
            paginationWrapper.innerHTML = newPagination.innerHTML;
            // Dehde (PLP, minor 3): the <a> that was clicked has just been replaced, so focus fell back to
            // <body> and the next Tab restarted from the top of the document. Hand it to the new button when
            // there is one (same spot on screen, no scroll), otherwise to the first card that was just added.
            const nextButton = paginationWrapper.querySelector('[data-dehde-load-more]');
            const firstNewCard = columns[0] && columns[0].querySelector('a[href]');
            const focusTarget = nextButton || firstNewCard;
            if(focusTarget) focusTarget.focus({preventScroll: Boolean(nextButton)});
          } else{
            this.showButton = false;
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          if(!this.showButton) return this.hideButton();
          this.button.classList.remove('disabled');
          this.loader.classList.add('hidden');
        }
      );
    }

    hideButton(){
      const parent = this.parentElement;
      parent.style.display = 'none';
    }
  });
}